import React, { useState } from "react";
import PropTypes from "prop-types";
import privateAxios from "../../utils/axiosPrivate";
import { showToast } from "../../utils/utils";
import { buttonName, checklist, timeDaySubmitted } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import ModalSelectFilter from "../../pages/reports/industry-sectors/ModalSelectFilter";
import Style from "./modal.module.scss";
import { LENDING, MONTH, STATUS12 } from "../../utils/constants/appConstants";
import { getIndustryReportDownloadUrl } from "../../utils/constants/apiEndPoints";
import CommonModal from "./CommonModal";
export default function IndustryReportDownloadModal({ isOpen, toggle }) {
  const [view, setView] = useState(MONTH);
  const [timePeriods, setTimePeriods] = useState(STATUS12);
  const [country, setCountry] = useState("");
  const [dataType, setDataType] = useState(LENDING);

  const initialLoading = {
    downloadBtn: false,
    filterDownload: false
  };

  const [loading, setLoading] = useState(initialLoading);

  const handleDownload = async () => {
    try {
      setLoading((prev) => ({
        ...prev,
        downloadBtn: true,
        filterDownload: true
      }));

      const response = await privateAxios.get(getIndustryReportDownloadUrl, {
        params: {
          viewType: view || MONTH,
          periods: timePeriods || STATUS12,
          country: country || undefined,
          dataType: dataType || LENDING
        },
        responseType: "blob"
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Optional: dynamic file name
      link.setAttribute(
        "download",
        `Industry_Sector_Report_${dataType}_${view}_${timePeriods}.xlsx`
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      showToast(checklist.errors.fileDownload, showToastType.success);
      toggle();
      setView(MONTH);
      setTimePeriods(STATUS12);
      setCountry("");
      setDataType(LENDING);
    } catch {
      showToast(
        timeDaySubmitted?.reportModal.errMsg.item3,
        showToastType.error
      );
    } finally {
      setLoading((prev) => ({
        ...prev,
        downloadBtn: false,
        filterDownload: false
      }));
    }
  };

  const handleOnClose = () => {
    toggle();
    setView(MONTH);
    setTimePeriods(STATUS12);
    setCountry("");
    setDataType(LENDING);
  };
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={timeDaySubmitted?.reportModal?.title}
      modalClassName={`${Style.xeroModal} modal-xl`}
      bodyClassName={`${Style.aiScModalContent} modal-content`}
      footerButtons={[
        {
          label: loading.downloadBtn
            ? buttonName?.loading
            : buttonName?.download,
          className: "btn btn-primary",
          onClick: handleDownload
        },
        {
          label: buttonName?.close,
          className: "btn btn-blue",
          onClick: handleOnClose
        }
      ]}
    >
      <div className="row report_download">
        <div className="col-md-12">
          <ModalSelectFilter
            setView={setView}
            setTimePeriods={setTimePeriods}
            setCountry={setCountry}
            view={view}
            timePeriods={timePeriods}
            country={country}
            dataType={dataType}
            setDataType={setDataType}
            loading={loading.filterDownload}
          />
        </div>
      </div>
    </CommonModal>
  );
}

IndustryReportDownloadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};
